import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { RootState, useAppDispatch } from "../../redux/store";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import LoadingComp from "../../components/re-usable/loading/loading";

const WorkforceReport = () => {
  const path = "Resources%2Fworkforce-report";

  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [htmlString, setHtmlString] = useState("Loading...");

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]) {
      if (RapsEuropeData[0].result[0] && RapsEuropeData[0].result[0].description) {
        setHtmlString(RapsEuropeData[0].result[0].description);
      }
    }
  }, [RapsEuropeData]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check
  
  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={path} isBreadcrumbpath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
      </TwoColumnLayOut>
    </>
  );
};

export default WorkforceReport;
